<template>
    <SOSlotBase :bg-white="true" :loading="pageSetting.loading">
        <template v-slot:loading-page>
            <SOLoadingPage />
        </template>

        <template v-slot:title-bar>
            <SOTitleBar :page-title="pageSetting.pageTitle" :type="'back'" @back="back" />
        </template>

        <template v-slot:content>
            <div class="flex-100 w-limit">
                <div class="flex-1">
                    <div class="p-x-20 p-y-16">
                        <div class="p-d-16">
                            <SOInputSelect
                                :required="true"
                                :title="'Beri dana ke'"
                                :selected="payload.to"
                                :placeholder="'Pilih kas workshop...'"
                                :options="optionsTo"
                                @option-selected="selectedTo"
                            />
                            <ErrorMessage class="error" label="Beri dana ke" :validation="$v.payload.to" />
                            <div class="f-regular f-12 f-c-midgrey">
                                Saldo awal: Rp. {{ formatRupiah(saldo.to.awal) }}
                            </div>
                            <div class="f-regular f-12 f-c-midgrey">
                                Saldo akhir: Rp. {{ formatRupiah(saldo.to.akhir) }}
                            </div>
                        </div>

                        <div class="p-d-16">
                            <SOInputSelect
                                :required="true"
                                :title="'Di transfer dari akun'"
                                :selected="payload.from"
                                :placeholder="'Pilih akun...'"
                                :options="optionsFrom"
                                @option-selected="selectedFrom"
                            />
                            <ErrorMessage class="error" label="Di transfer dari akun" :validation="$v.payload.from" />
                            <div class="f-regular f-12 f-c-midgrey">
                                Saldo awal: Rp. {{ formatRupiah(saldo.from.awal) }}
                            </div>
                            <div class="f-regular f-12 f-c-midgrey">
                                Saldo akhir: Rp. {{ formatRupiah(saldo.from.akhir) }}
                            </div>
                        </div>

                        <div>
                            <SOInputNominal
                                :title="'Nominal'"
                                :placeholder="'123.456'"
                                :required="true"
                                :prefix-left="true"
                                :maxValue="getMaxValue"
                                :prefix="'Rp'"
                                :use-autocomplete="false"
                                :use-comma="true"
                                @input="changeNominal"
                            />
                            <ErrorMessage class="error" label="Nominal" :validation="$v.payload.nominal.formatted" />
                        </div>
                    </div>

                    <div class="separator"></div>

                    <div class="p-x-20 p-y-16">
                        <div class="p-d-16">
                            <SOInputDateTime
                                :required="true"
                                id="waktu-permintaan-dana-outlet"
                                :title="'Waktu transfer'"
                                :max-date="getDateNow"
                                :value="$moment().format('DD/MM/YYYY HH:mm')"
                                @get-date="
                                    (v) => {
                                        payload.waktu = v;
                                    }
                                "
                            />
                            <p class="m-d-0 f-12 f-c-midgrey f-regular">
                                Waktu digunakan sebagai acuan pencatatan di jurnal.
                            </p>
                            <ErrorMessage class="error" label="Waktu transfer" :validation="$v.payload.waktu" />
                        </div>

                        <div class="p-d-16">
                            <SOInputSelect
                                :title="'Penanggung jawab'"
                                :selected="payload.penanggungJawab"
                                :placeholder="'Pilih karyawan...'"
                                :options="optionsKaryawan"
                                @option-selected="
                                    (v) => {
                                        payload.penanggungJawab = v;
                                    }
                                "
                            />
                            <ErrorMessage
                                class="error"
                                label="Penanggung jawab"
                                :validation="$v.payload.penanggungJawab"
                            />
                        </div>

                        <div>
                            <SOInputRegular
                                :title="'Catatan (Opsional)'"
                                :placeholder="'Catatan...'"
                                :value="''"
                                :validation="'alphanumeric'"
                                v-model="payload.catatan"
                            />
                        </div>
                    </div>
                </div>

                <div class="p-d-24 w-limit">
                    <div class="p-x-20">
                        <SOButton
                            :text="'Beri Dana'"
                            :primary="true"
                            :full="true"
                            :disable="pageSetting.btn.save.disabled"
                            :loading="pageSetting.btn.save.loading"
                            @action="create"
                        />
                    </div>
                </div>
            </div>
        </template>
    </SOSlotBase>
</template>

<script>
import { mapGetters } from "vuex";
import { minLength, required } from "vuelidate/lib/validators";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOInputNominal from "@/so-components/global/input/SOInputNominal";
import SOInputDateTime from "@/so-components/global/input/SOInputDateTime";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import ErrorMessage from "@/component-items/ErrorMessage";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
    name: "PermintaanKasWorkshopCreate",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        SOInputSelect,
        SOInputNominal,
        SOInputDateTime,
        SOInputRegular,
        ErrorMessage,
        SOButton,
    },
    computed: {
        ...mapGetters("metaModule", {
            karyawan: "getKaryawanAll",
            financialAccountFund: "getFinancialAccountFund",
            listKeuanganKasWorkshop: "getListKeuanganKasWorkshop",
        }),
        getMaxValue() {
            let { awal } = this.saldo.from;

            return parseInt(awal).toString();
        },
        getDateNow() {
            return `${this.$moment().format("YYYY-MM-DD")}T23:59`;
        },
    },
    data() {
        return {
            pageSetting: {
                pageTitle: "Beri Dana ke Workshop",
                loading: true,
                btn: {
                    save: {
                        disabled: false,
                        loading: false,
                    },
                },
            },
            optionsTo: [],
            optionsFrom: [],
            optionsKaryawan: [],
            payload: {
                to: "",
                from: "",
                nominal: {
                    formatted: "",
                    raw: 0,
                },
                waktu: "",
                penanggungJawab: "",
                catatan: "",
                idworkshop: "",
            },
            saldo: {
                from: {
                    awal: 0,
                    akhir: 0,
                },
                to: {
                    awal: 0,
                    akhir: 0,
                },
            },
        };
    },
    validations: {
        payload: {
            to: {
                required,
            },
            from: {
                required,
            },
            nominal: {
                formatted: {
                    required,
                    minLength: minLength(1),
                },
            },
            waktu: {
                required,
            },
            penanggungJawab: {
                required,
            },
        },
    },
    mounted() {
        this.init();
        this.smartTrackingView("add_permintaan_workshop");
    },
    methods: {
        back() {
            this.$router.back();
        },
        async init() {
            await this.getListKeuanganKas();
            await this.getFinancialAccountFund();
            await this.getKaryawan();
            this.pageSetting.loading = false;
        },

        async getListKeuanganKas() {
            this.pageSetting.loading = true;
            const res = await this.$store.dispatch("metaModule/fetchListKeuanganKasWorkshop");
            if (res.success) {
                this.pageSetting.loading = false;
                this.optionsTo = [];
                this.listKeuanganKasWorkshop.forEach((v) => {
                    this.optionsTo = [
                        ...this.optionsTo,
                        {
                            id: v.idakun,
                            text: v.nama_akun,
                        },
                    ];
                });
            } else {
                this.pageSetting.loading = false;
                this.$toast.error(res.err);
            }
        },
        async getFinancialAccountFund() {
            this.pageSetting.loading = true;
            const res = await this.$store.dispatch("metaModule/fetchFinancialAccountFund");

            if (res.success) {
                this.pageSetting.loading = false;
                this.optionsFrom = [];
                this.financialAccountFund.forEach((v) => {
                    this.optionsFrom = [
                        ...this.optionsFrom,
                        {
                            id: v.idakun,
                            text: v.nama_akun,
                        },
                    ];
                });
            } else {
                this.pageSetting.loading = false;
                this.$toast.error(res.err);
            }
        },
        async getKaryawan() {
            this.pageSetting.loading = true;
            const res = await this.$store.dispatch("metaModule/fetchKaryawanAll");

            if (res.success) {
                this.pageSetting.loading = false;
                this.optionsKaryawan = [];
                this.karyawan.forEach((v) => {
                    this.optionsKaryawan = [
                        ...this.optionsKaryawan,
                        {
                            id: v.idkaryawan,
                            text: v.nama,
                        },
                    ];
                });
            } else {
                this.pageSetting.loading = false;
                this.$toast.error(res.err);
            }
        },

        selectedTo(val) {
            this.payload.to = val;
            let selectedArray = this.listKeuanganKasWorkshop.filter((v) => v.idakun === val);
            if (selectedArray.length > 0) {
                this.saldo.to.awal = selectedArray[0].saldo_akhir;
                this.saldo.to.akhir = selectedArray[0].saldo_akhir + this.payload.nominal.raw;
                this.payload.idworkshop = selectedArray[0].related_id;
            }
        },
        selectedFrom(val) {
            if (val === this.payload.to) {
                this.$toast.error("Akun penerima tidak boleh sama dengan akun pemberi ");
            } else {
                this.payload.from = val;
                let selectedArray = this.financialAccountFund.filter((v) => v.idakun === val);
                if (selectedArray.length > 0) {
                    this.saldo.from.awal = selectedArray[0].saldo_akhir;
                    this.saldo.from.akhir = selectedArray[0].saldo_akhir - this.payload.nominal.raw;
                }
            }
        },
        changeNominal(val) {
            this.payload.nominal = val;
            this.saldo.to.akhir = this.saldo.to.awal + this.payload.nominal.raw;
            this.saldo.from.akhir = this.saldo.from.awal - this.payload.nominal.raw;
        },

        errorValidation() {
            this.$v.payload.to.$touch();
            this.$v.payload.from.$touch();
            this.$v.payload.nominal.formatted.$touch();
            this.$v.payload.waktu.$touch();
            this.$v.payload.penanggungJawab.$touch();
            return (
                this.$v.payload.to.$invalid ||
                this.$v.payload.from.$invalid ||
                this.$v.payload.nominal.formatted.$invalid ||
                this.$v.payload.waktu.$invalid ||
                this.$v.payload.penanggungJawab.$invalid
            );
        },
        async create() {
            this.smartTrackingClick("simpan_permintaan_outlet");
            if (this.errorValidation()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }
            let { awal } = this.saldo.from;
            if (awal < this.payload.nominal.raw) {
                this.$toast.error("Nominal tidak boleh libh dari Saldo Awal");
                return;
            }
            let form = new FormData();
            form.append("idakun_debet", this.payload.to);
            form.append("idakun_kredit", this.payload.from);
            form.append("idkaryawan", this.payload.penanggungJawab);
            form.append("idworkshop", this.payload.idworkshop);
            form.append("nominal", this.payload.nominal.raw);
            form.append("keterangan_status", this.payload.catatan);
            form.append("waktu_transfer", this.$moment(this.payload.waktu).format("YYYY-MM-DD HH:mm:ss"));

            this.pageSetting.btn.save.loading = true;
            this.pageSetting.btn.save.disabled = true;
            const res = await this.$store.dispatch("permintaanKasWorkshopModule/createPermintaanKasWorkshop", form);
            this.pageSetting.btn.save.loading = false;
            this.pageSetting.btn.save.disabled = false;
            if (!res.success) {
                this.$toast.error(res.err);
                return;
            }
            this.$toast.success(res.msg);
            await this.$store.commit("permintaanKasWorkshopModule/resetPermintaanKasWorkshop");
            await this.$router.back();
        },
    },
};
</script>
